// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import BusComponent from "../../BusComponent";
import Tooltip from "../../Tooltip";
import SummaryLevelSelector from "../../summaryLevelSelector/SummaryLevelSelector";
import Menu from "../../mapPanel/Menu";


class GeographyLevelDropdown extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showDropdownOptions: false,
            activeSummaryLevelLabel: '',
        }
        this.bindGluBusEvents({
            MAP_VIEWER: this.handleMapUpdate,
            DRAGONFLY_MAP_CREATED: this.handleMapUpdate,
            MAP_MASKING_FILTER_REMOVED: this.handleMapUpdate,
            MAP_PREFERRED_SUMMARY_LEVEL_CHANGED: this.handleMapUpdate,
            MAP_ZOOM_END: this.handleMapUpdate,
        });
    }

    componentDidMount() {
        this.emit('MAP_GET_MAP_VIEWER');
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    getActiveSummaryLevelFromMap(mapViewer) {
        const { intl } = this.props;

        const visibleSummaryLevels = mapViewer.dragonflyMapData.visibleSummaryLevels;
        const summaryLabel = visibleSummaryLevels.find(it => it.id === mapViewer.activeSummaryLevel.id).label;
        return summaryLabel.replace(`${intl.formatMessage({ id: 'census' })} `, '')
    }

    handleMapUpdate(eventMap) {
        const { mapInstance, intl } = this.props;

        if (eventMap.source.id === mapInstance.id && eventMap.source.dragonflyMapData) {
            this.setState({
                activeSummaryLevelLabel: this.getActiveSummaryLevelFromMap(eventMap.source),
            });
        } else {
            this.setState({
                activeSummaryLevelLabel: intl.formatMessage({
                    id: 'dataBrowser.noVisibleDataLayers',
                }),
            });
        }
    }

    toggleDropdown = () => {
        this.setState(prevState => ({
            showDropdownOptions: !prevState.showDropdownOptions,
        }))
    }

    render() {
        const { intl, mapInstance } = this.props;
        const { showDropdownOptions, activeSummaryLevelLabel } = this.state;

        const actionButton = (
            <Tooltip
                placement="bottom"
                mouseEnterDelay={0.5}
                mouseLeaveDelay={0}
                overlay={intl.formatMessage({id: 'dataBrowser.changeGeographyLevel'})}
            >
                <button
                    className="basemap-editor__visualization-editor-container__btn-container__btn"
                    data-testid="geography-level-trigger"
                    onClick={this.toggleDropdown}
                    ref={e => { this.trigger = e; }}
                >
                    <div className="flex-it row center" style={{gap: '6px'}}>
                        <span style={{color: 'rgba(0, 0, 0, 0.62)'}}> by </span>
                        <span> {activeSummaryLevelLabel} </span>
                    </div>
                    <i
                        className="material-icons"
                        style={{alignItems: 'flex-end'}}
                    > keyboard_arrow_down </i>
                </button>
            </Tooltip>
        );

        return (
            <div className={"basemap-editor__visualization-editor-container__btn-container large space-between"}>
                {actionButton}
                <div className="basemap-editor__visualization-editor-container__btn-container__summary-btn">
                    {showDropdownOptions &&
                        <Menu onClose={this.toggleDropdown}>
                            <SummaryLevelSelector
                                mapInstanceId={mapInstance.id}
                                title={intl.formatMessage({ id: 'dataBrowser.geographyLevel' })}
                                closeDropdown={this.toggleDropdown}
                            />
                        </Menu>
                    }
                </div>
            </div>
        );
    }
}


GeographyLevelDropdown.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(GeographyLevelDropdown);
